module.exports = __webpack_public_path__ + "static/media/arrow.d34d6ce6.svg";